var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'relative-block',
        'slim',
        ("count-" + (_vm.layout.data.length))
    ]},[_c('h3',[_c('IconPlus'),_vm._v(_vm._s(_vm.layout.title)+"\n    ")],1),_c('div',{staticClass:"related-list"},_vm._l((_vm.layout.data),function(post){return _c("block-related",{key:post.id,tag:"component",attrs:{"post":post}},[_c('span',{staticClass:"caption"},[_vm._v(_vm._s(post.name))])])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }